import en from './en.js'
import ml from './ml.js'

export const translations = { en, ml }

export function translate(language, path, values = {}) {
  const source = translations[language] || translations.en
  const value = path.split('.').reduce((item, key) => item?.[key], source)
  const fallback = path.split('.').reduce((item, key) => item?.[key], translations.en)
  const resolved = value ?? fallback ?? path
  if (typeof resolved !== 'string') return resolved
  return Object.entries(values).reduce((text, [key, replacement]) => text.replaceAll(`{${key}}`, String(replacement)), resolved)
}
